<div class="tab-container">
    <!-- Tab Headers -->
    <div class="nav-tabs">
        @for (tab of tabs; track tab) {
<div class="tab" [class.active]="tab === activeTab" [class.disabled]="isDisabled(tab)"
            (click)="selectTab(tab)">
            {{ tab }}
        </div>
}
    </div>

    <!-- Tab Content -->
    @if (getActiveTabData()) {
<div class="tab-content">
        <div class="tab-sections">
            <!-- Loop through sections in the active tab -->
            @for (section of getActiveTabData()?.sections; track section) {
<div class="section-container">


                @for (section of getActiveTabData()?.sections; track section) {
<div class="section-container">
                    @if (section.type === 'section') {
<app-sections [section]="section" [formGroup]="formGroup"
                        [disabled]="disabled"></app-sections>
}
                </div>
}


            </div>
}
        </div>
    </div>
}
</div>